export default __webpack_public_path__ + "static/media/b1.e8f5a0b2.jpg";